import { use_slice_ui } from '@/hooks/store/use_slices';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { G_BUTTON__field_ui_change_visibility } from './_buttons/G_BUTTON__field_ui_change_visibility';
import { G_BUTTON__field_use_as_grid2d_column } from './_buttons/G_BUTTON__field_use_as_grid2d_column';
import { G_BUTTON__field_use_as_grid2d_row } from './_buttons/G_BUTTON__field_use_as_grid2d_row';
import { G_DROPDOWN__field__store_interaction } from './_buttons/G_DROPDOWN__field__store_interaction';
import { G_UI_FIELD__header_icon_lock } from './G_UI_FIELD__header_icon_lock';
import { G_UI_FIELD__info } from './G_UI_FIELD__info';

interface Props {
  field: FIELD__base;
  children?: JSX.Element;
  hide_buttons_grid2d_dimension?: boolean;
}

export function G_UI_FIELD__header({ field, children, hide_buttons_grid2d_dimension = false }: Props) {
  /*
   * STORE
   */
  const { g_general__sidebar_field_hovered } = use_slice_ui(['g_general__sidebar_field_hovered']);
  /*
   * STATE
   */
  let is_hovered = g_general__sidebar_field_hovered.meta.field_id === field.meta.field_id;

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_title() {
    if (is_hovered) return null;

    let class_name = 'text-bar-foreground';

    // todo: make header sticky
    return (
      <div className={`px-1 size-full flex items-center justify-between text-xs text-left ${class_name}`}>
        <span className=" flex items-center gap-1">
          <G_UI_FIELD__info {...{ field }} />
          <span className="truncate max-w-48">{field.meta.sort_criteria}</span>
        </span>
        <G_UI_FIELD__header_icon_lock {...{ field }} />
      </div>
    );
  }

  function render_actions() {
    if (!is_hovered) return null;

    return (
      <div className="size-full flex flex-row items-center justify-between px-1">
        <G_UI_FIELD__info {...{ field }} />
        <G_DROPDOWN__field__store_interaction {...{ field }} />
        {children}
        <G_BUTTON__field_ui_change_visibility {...{ field }} />
        {render_buttons_grid2d_dimension()}
      </div>
    );
  }

  function render_buttons_grid2d_dimension() {
    if (hide_buttons_grid2d_dimension) return null;

    return (
      <>
        <G_BUTTON__field_use_as_grid2d_column {...{ field }} />
        <G_BUTTON__field_use_as_grid2d_row {...{ field }} />
      </>
    );
  }

  /*
   * HTML
   */

  return (
    <div className="w-full h-5 bg-bar rounded-t-lg">
      {render_actions()}
      {render_title()}
    </div>
  );
}
